import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '@wit-support/ui';
export const Actions = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex flex-row items-center justify-end gap-2 pt-2', className), ...props })));
Actions.displayName = 'Actions';
//# sourceMappingURL=actions.js.map